module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.chapters.length) + " task categories\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new task category")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-chapter-name"
    }
  }, [_vm._v("Category Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.name),
      expression: "newChapter.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-chapter-name"
    },
    domProps: {
      "value": (_vm.newChapter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "chapter-slug"
    }
  }, [_vm._v("Slug")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.slug),
      expression: "newChapter.slug"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "name": "chapter-desc",
      "id": "chapter-slug"
    },
    domProps: {
      "value": (_vm.newChapter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "chapter-slug"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChapter.color),
      expression: "newChapter.color"
    }],
    staticClass: "form-control form-control__color",
    attrs: {
      "type": "color",
      "name": "chapter-desc",
      "id": "chapter-color"
    },
    domProps: {
      "value": (_vm.newChapter.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChapter, "color", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (blue)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedBlue),
      expression: "!isThumbnailFileUploadedBlue"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_blue_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'blue')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedBlue) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.image + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedBlue) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'blue')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (gray)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedGray),
      expression: "!isThumbnailFileUploadedGray"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_gray_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'gray')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedGray) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.imageGray + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedGray) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'gray')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element featured-image"
  }, [_c('span', {
    staticClass: "form-label color-2-63"
  }, [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThumbnailFileUploadedHigh),
      expression: "!isThumbnailFileUploadedHigh"
    }],
    staticClass: "form-label color-2-63 form-label--file-upload"
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "id": "uploadThumbnail_high_0",
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "formInfo.thumbnail"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event, 0, 'high')
      }
    }
  })]), _vm._v(" "), (_vm.isThumbnailFileUploadedHigh) ? _c('div', {
    staticClass: "thumbnailFilePreview",
    style: ({
      backgroundImage: 'url(' + _vm.newChapter.imageHigh + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isThumbnailFileUploadedHigh) ? _c('button', {
    staticClass: "btn btn--remove-element",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeThumbnail(0, 'high')
      }
    }
  }, [_c('span', {
    staticClass: "btn__text"
  }, [_vm._v("-Remove image")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-chapter-desc"
    }
  }, [_vm._v("Key information")]), _vm._v(" "), _c('vue-editor', {
    staticClass: "form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar
    },
    model: {
      value: (_vm.newChapter.description),
      callback: function($$v) {
        _vm.$set(_vm.newChapter, "description", $$v)
      },
      expression: "newChapter.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCategory()
      }
    }
  }, [_vm._v("Create task category")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Image")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Category name..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedChapters), function(chapter, i) {
    return _c('tr', [(chapter.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(chapter.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [(chapter.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "border": "none"
      },
      style: ({
        backgroundImage: 'url(' + chapter.image + ')'
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(chapter.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(chapter.isChild ? '- ' + chapter.slug : chapter.slug) + "\n          ")]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(chapter.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (chapter.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeCategory(chapter.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (chapter.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.image),
        expression: "!chapter.image"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_blue_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'blue')
        }
      }
    })]), _vm._v(" "), (chapter.image) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.image + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.image) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'blue')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.imageGray),
        expression: "!chapter.imageGray"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_gray_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'gray')
        }
      }
    })]), _vm._v(" "), (chapter.imageGray) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.imageGray + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.imageGray) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'gray')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-element featured-image"
    }, [_c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!chapter.imageHigh),
        expression: "!chapter.imageHigh"
      }],
      staticClass: "form-label color-2-63 form-label--file-upload"
    }, [_c('div', {
      staticClass: "upload-text"
    }, [_vm._v("+Upload image")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "id": 'uploadThumbnail_high_' + chapter.id,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "formInfo.thumbnail"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, chapter.id, 'high')
        }
      }
    })]), _vm._v(" "), (chapter.imageHigh) ? _c('div', {
      staticClass: "thumbnailFilePreview",
      style: ({
        backgroundImage: 'url(' + chapter.imageHigh + ')'
      })
    }) : _vm._e(), _vm._v(" "), (chapter.imageHigh) ? _c('button', {
      staticClass: "btn btn--remove-element",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeThumbnail(chapter.id, 'high')
        }
      }
    }, [_c('span', {
      staticClass: "btn__text"
    }, [_vm._v("-Remove image")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-color-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.color),
        expression: "chapter.color"
      }],
      staticClass: "form-control form-control__color",
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (chapter.color)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(chapter, "color", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.name),
        expression: "chapter.name"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (chapter.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(chapter, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('vue-editor', {
      staticClass: "form-control form-control__editor",
      attrs: {
        "name": "content",
        "editorToolbar": _vm.editorToolbar
      },
      model: {
        value: (chapter.description),
        callback: function($$v) {
          _vm.$set(chapter, "description", $$v)
        },
        expression: "chapter.description"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(chapter.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editCategory(chapter.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Task categories")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ad45258","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ChaptersList.vue
// module id = 1040
// module chunks = 0